import React, { type ReactEventHandler, useCallback } from 'react';
import { TariffSwitch } from 'reactApp/ui/TariffCardNew/components/TariffSwitch';
import type { SwitchOption } from 'reactApp/ui/TariffCardNew/components/TariffSwitch.types';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

import styles from './TabsSelector.css';

const switchOptions: [SwitchOption, SwitchOption] = [
    {
        value: ETabsName.month,
        text: 'На месяц',
    },
    {
        value: ETabsName.year,
        text: 'На год',
    },
];

interface TabsSelectorProps {
    activeTab: ETabsName;
    setActiveTab: (tab: ETabsName) => void;
}

export const TabsSelector: React.FC<TabsSelectorProps> = ({ activeTab, setActiveTab }) => {
    const onSwitchClick: ReactEventHandler = useCallback(
        (event) => {
            event.stopPropagation();
            setActiveTab(activeTab === ETabsName.month ? ETabsName.year : ETabsName.month);
        },
        [activeTab, setActiveTab]
    );

    return (
        <div className={styles.root}>
            <TariffSwitch gray checked={activeTab === ETabsName.year} onClick={onSwitchClick} options={switchOptions} />
        </div>
    );
};
